import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between gap-3 border-b border-slate-200 px-5 py-4 dark:border-slate-700" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "flex justify-end gap-2 border-t border-slate-200 px-5 py-4 dark:border-slate-700" }
const _hoisted_4 = ["onClick"]

import { LogOutIcon, XIcon } from "@lucide/vue"
import ModalHost from "@/application/providers/ModalHost.vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'LogoutModal',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue", "confirm"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalHost, {
    "model-value": __props.modelValue,
    "labelled-by": "logout-modal-title",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (emit('update:modelValue', $event)))
  }, {
    default: _withCtx(({ close }) => [
      _createElementVNode("header", _hoisted_1, [
        _cache[2] || (_cache[2] = _createElementVNode("h2", {
          id: "logout-modal-title",
          class: "min-w-0 truncate text-base font-semibold text-slate-950 dark:text-slate-50"
        }, " Завершить сессию? ", -1)),
        _createElementVNode("button", {
          class: "inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-md text-slate-500 transition hover:bg-slate-100 hover:text-slate-950 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:text-slate-400 dark:hover:bg-slate-800 dark:hover:text-slate-50",
          type: "button",
          "aria-label": "Закрыть окно",
          onClick: close
        }, [
          _createVNode(_unref(XIcon), {
            class: "h-5 w-5",
            "aria-hidden": "true"
          })
        ], 8, _hoisted_2)
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "px-5 py-4 text-sm leading-6 text-slate-700 dark:text-slate-300" }, " Текущая сессия будет завершена, а подключение к realtime будет закрыто. ", -1)),
      _createElementVNode("footer", _hoisted_3, [
        _createElementVNode("button", {
          class: "inline-flex min-h-10 items-center justify-center rounded-md border border-slate-300 px-4 text-sm font-medium text-slate-700 transition hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:border-slate-600 dark:text-slate-200 dark:hover:bg-slate-800",
          type: "button",
          onClick: close
        }, " Отмена ", 8, _hoisted_4),
        _createElementVNode("button", {
          class: "inline-flex min-h-10 items-center justify-center gap-2 rounded-md bg-red-600 px-4 text-sm font-medium text-white transition hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2",
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('confirm')))
        }, [
          _createVNode(_unref(LogOutIcon), {
            class: "h-4 w-4",
            "aria-hidden": "true"
          }),
          _cache[3] || (_cache[3] = _createTextVNode(" Выйти ", -1))
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})